﻿window.cBuilderEmailWidgetCtrlEmail = function cBuilderEmailWidgetCtrlEmail(option) {
    var Me = this;

    // =========================================================
    // Héritage
    // =========================================================

    window.cBuilderEmailWidgetCtrl.call(this, option);


    // =========================================================
    // Propriétés spécifiques
    // =========================================================

    this.nomWidget = "dxwidgetformemail"
    this.icone = "fas fa-at";
    this.nomBt = "Adresse email";
    this.titleBt = "Saisie d'une adresse email"
    this.labelCtrl = "Adresse email"
    this.typeDevExpress = "dxCtrlTextEmail"


    // =========================================================
    // Surcharge mCreateElement
    // =========================================================

    var mCreateElementParent = this.mCreateElement;

    this.mCreateElement = function () {

        // Appel de la méthode du parent
        mCreateElementParent.call(Me);

        // =====================================================
        // AJOUT PERSONNEL DE LA CLASSE FILLE
        // =====================================================

        var $Td = Me.mGetTdSaisie();

        Me.mAddCtrlDevExpress()
    };

    this.mAddCtrlDevExpress = function (onValueChangedDevexpress) {
        Me.mGetTdSaisie().empty()
        var ctrl = $("<div class='ctrldevexpress " + Me.mGetTypeCtrlDevexpress() + " electrl" + Me.mGetIndexdevexpress() + " " + (Me.mGetTdSaisie().attr("obligatoire") == "1" ? "obligatoire" : "") + "'/>").appendTo(Me.mGetTdSaisie()).dxCtrlTextEmail({
            label: (Me.mGetTdSaisie().attr("obligatoire") == "1" ? "* " : "") + Me.mGetTdSaisie().attr("label"),
            labelMode: "floating",
            stylingMode: "outlined", //pour voir la bordure,
            onValueChanged: function (e) {
                ctrl.element().css("background-color", "")
                ctrl.element().closest("td").css("border-left", "")
                if (onValueChangedDevexpress) onValueChangedDevexpress(ctrl, Me.mGetTdSaisie().attr("indexdevexpress"), Me.mGetTdSaisie().attr("tri"), Me.mGetTdSaisie().attr("typedevexpress"), "", Me.mGetTdSaisie().attr("typchamp"), Me.mGetTdSaisie().attr("label"), e.value)
            }
        }).dxCtrlTextEmail("instance")
        ctrl.isEmpty = function () { return (ctrl.option("value") == null || ctrl.option("value").length == 0) }
        return ctrl
    }


    // =========================================================
    // Surcharge mAddCtrlSaisie
    // =========================================================

    var mAddCtrlSaisieParent = this.mAddCtrlSaisie;

    this.mAddCtrlSaisie = function (contentElement) {

        // Appel de la méthode du parent
        mAddCtrlSaisieParent.call(Me, contentElement);
    };
};